import { useContext } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { wireAccessByObjectTypeId } from 'automation-ui-action-features/access/wireAccessByObjectTypeId';
import { getCreateMetadata } from 'automation-ui-canvas/flow/records/Flow/flowUtils';
import { getSourceApp } from 'automation-ui-canvas/selectors/embedSelectors';
import wireFlow from 'automation-ui-canvas/decorators/WiredFlowDecorator';
import AppContext from 'automation-ui-core/context/AppContext';
import { wireAuthConsumer } from 'automation-ui-core/context/AuthContext';
import { EMAIL_TYPE_WORKFLOWS_ACCESS } from 'automation-ui-canvas/constants/Scopes';
import * as AccessTypes from 'automation-ui-action-features/access/constants/AccessTypes';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import { getSpecificActionAccessLevel } from 'automation-ui-action-features/access/utils/accessLevelUtils';
import EmailActionCard from 'automation-ui-action-features/actions/email/EmailActionCard';
import { jsx as _jsx } from "react/jsx-runtime";
// TODO ZS 12/4/20: we need to move away from accessing the
// flow from action cards as it will hinder the migration
const mapStateToProps = (state, {
  flow
}) => {
  const sourceApp = flow ? getCreateMetadata(flow).getSourceApp() : getSourceApp(state);
  return {
    // for wireAccessByObjectTypeId
    sourceApp
  };
};
const wireDisableEmailLink = WrappedComponent => props => {
  const {
    isContextualEmbed
  } = useContext(AppContext);
  const hasAutomatedEmailAccess = props.hasScope(EMAIL_TYPE_WORKFLOWS_ACCESS);
  const disableEmailLink = isContextualEmbed && !hasAutomatedEmailAccess;
  return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
    disableEmailLink: disableEmailLink
  }));
};
export default compose(wireAuthConsumer, withRouter, wireFlow, connect(mapStateToProps), wireAccessByObjectTypeId, WrappedComponent => props => /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
  hasMarketingEmailAccess: getSpecificActionAccessLevel(props.access, ActionTypes.EMAIL) === AccessTypes.USER_ACCESS
})), wireDisableEmailLink)(EmailActionCard);